import { ensureInstance, ensureInstanceArray } from "../../utils/typeUtils";
import { AISystemImpact } from "../risk/AISystemImpact";
import { MitigationRequirement, RiskRegistryItem } from "./RiskRegistry";
import { type TRiskRank, type TRiskRankWithNA } from "../risk/Risk";




export class RiskPlusTitlePage {
    
    title: string = ""
    subtitle: string = ""
    useCaseTitle: string = ""
    client: string = ""
    reportDate: Date = new Date()
    riskAssessmentStage: string = ""

    constructor(init?: Partial<RiskPlusTitlePage>) {
        Object.assign(this, init);
         
        // ensure nested class instance
        this.reportDate = ensureInstance(init?.reportDate, Date, () => new Date());
    }
}


export class RiskImpactSummary{

    impactArea: string = ""
    riskRating: TRiskRank = "negligible"
    description: string = ""
    constructor(init?: Partial<RiskImpactSummary>) {
        Object.assign(this, init);
    }
}


export class ExecutiveReadinessVerdict {
    
    overallVerdict: string = ""  
    overallRiskRank: TRiskRank = "negligible";
    useCaseImpacts: RiskImpactSummary[] = [];
    executiveInterpretation: string[] = [];
    scopeNotes: string[] = [];

    constructor(init?: Partial<ExecutiveReadinessVerdict>) {
        Object.assign(this, init);
        this.useCaseImpacts = ensureInstanceArray(this.useCaseImpacts, RiskImpactSummary);
    }
}


export class KeyRisk {
    id: string = "";
    label: string = "";
    harmCategory: string = "";
    riskRating: TRiskRankWithNA = "n/a";
    constructor(init?: Partial<KeyRisk>) {
        Object.assign(this, init);
    }
}


export class DeploymentRequirement {
    label: string = "";

    requirement: string = "";

    constructor(init?: Partial<DeploymentRequirement>) {
        Object.assign(this, init);
    }

}





export class LeadershipSummary {
    riskExposureSummary: string = "";
    keyRisks: KeyRisk[] = [];
    deploymentRequirements: DeploymentRequirement[] = [];

    constructor(init?: Partial<LeadershipSummary>) {
        Object.assign(this, init);
        this.keyRisks = ensureInstanceArray(this.keyRisks, KeyRisk);
        this.deploymentRequirements = ensureInstanceArray(this.deploymentRequirements, DeploymentRequirement);
    }
}



export class RiskDriver{
    label: string = "";
    description: string = "";
    constructor(init?: Partial<RiskDriver>) {
        Object.assign(this, init);
    }
}

export class UseCaseOverview {

    useCaseSummary: string = "";
    intendedPurposes: string[] = [];
    intendedUsers: string[] = [];
    deploymentContexts: string[] = [];
    dataContexts: string[] = [];
    keyStakeholders: string[] = [];
    riskDrivers: RiskDriver[] = [];

    constructor(init?: Partial<UseCaseOverview>) {
        Object.assign(this, init);
        this.riskDrivers = ensureInstanceArray(this.riskDrivers, RiskDriver);
    }
}

export class DeploymentCharacteristic{
    label: string = "";
    description: string = "";

    constructor(init?: Partial<DeploymentCharacteristic>) {
        Object.assign(this, init);
    }
}



export class OrganisationalImpact{
    label: string = "";
    description: string = "";

    constructor(init?: Partial<OrganisationalImpact>) {
        Object.assign(this, init);
    }
}



export class DeploymentProfile{

    deploymentCharacteristics: DeploymentCharacteristic[] = [];
    organisationalImpacts: OrganisationalImpact[] = [];
    riskConcentration: string = "";
    aiSystemImpact: AISystemImpact = new AISystemImpact(); 

    constructor(init?: Partial<DeploymentProfile>) {
        Object.assign(this, init);
        this.deploymentCharacteristics = ensureInstanceArray(this.deploymentCharacteristics, DeploymentCharacteristic);
        this.organisationalImpacts = ensureInstanceArray(this.organisationalImpacts, OrganisationalImpact);
        this.aiSystemImpact = ensureInstance(this.aiSystemImpact, AISystemImpact, () => new AISystemImpact());
    }

}


export class DeploymentRequirementsSection {

    deploymentRequirementSummary: string = "";
    mitigationRequirements: MitigationRequirement[] = [];
    disclaimerNotes: string[] = [];
    constructor(init?: Partial<DeploymentRequirementsSection>) {
        Object.assign(this, init);
        this.mitigationRequirements = ensureInstanceArray(this.mitigationRequirements, MitigationRequirement);
    }
}



export class RiskProfilePillar {
    label: string = "";
    riskRank: TRiskRankWithNA = "n/a";
    characteristicsHistogram: Record<TRiskRankWithNA, number> = {
        "n/a": 0,
        "negligible": 0,
        "low": 0,
        "moderate": 0,
        "high": 0,
        "critical": 0
    };

    histogramComment: string = "";
    executiveComment: string = "";

    summary: string = "";

    constructor(init?: Partial<RiskProfilePillar>) {
        Object.assign(this, init);
    }
}


export class RiskProfileSummary {
    pillars: RiskProfilePillar[] = []

    overallRiskRank: TRiskRankWithNA = "n/a";

    constructor(init?: Partial<RiskProfileSummary>) {
        Object.assign(this, init);
        this.pillars = ensureInstanceArray(this.pillars, RiskProfilePillar);
    }
}



export class RiskPlusReport {
    id: string = "";
    useCaseChat: string = "";
    titlePage: RiskPlusTitlePage = new RiskPlusTitlePage();
    executiveReadinessVerdict: ExecutiveReadinessVerdict = new ExecutiveReadinessVerdict();
    leadershipSummary: LeadershipSummary = new LeadershipSummary();
    useCaseOverview: UseCaseOverview = new UseCaseOverview();
    riskRegister: RiskRegistryItem[] = [];
    deploymentProfile: DeploymentProfile = new DeploymentProfile();
    deploymentRequirements: DeploymentRequirementsSection = new DeploymentRequirementsSection();
    riskProfileSummary: RiskProfileSummary = new RiskProfileSummary();

    constructor(init?: Partial<RiskPlusReport>) {
        Object.assign(this, init);
        this.titlePage = ensureInstance(this.titlePage, RiskPlusTitlePage, () => new RiskPlusTitlePage());
        this.executiveReadinessVerdict = ensureInstance(this.executiveReadinessVerdict, ExecutiveReadinessVerdict, () => new ExecutiveReadinessVerdict());
        this.leadershipSummary = ensureInstance(this.leadershipSummary, LeadershipSummary, () => new LeadershipSummary());
        this.useCaseOverview = ensureInstance(this.useCaseOverview, UseCaseOverview, () => new UseCaseOverview());
        this.riskRegister = ensureInstanceArray(this.riskRegister, RiskRegistryItem);
        this.deploymentProfile = ensureInstance(this.deploymentProfile, DeploymentProfile, () => new DeploymentProfile());
        this.deploymentRequirements = ensureInstance(this.deploymentRequirements, DeploymentRequirementsSection, () => new DeploymentRequirementsSection());
        this.riskProfileSummary = ensureInstance(this.riskProfileSummary, RiskProfileSummary, () => new RiskProfileSummary());
    }
}



























